import { render, staticRenderFns } from "./Salestaff.vue?vue&type=template&id=f2d56674&scoped=true"
import script from "./Salestaff.vue?vue&type=script&lang=js"
export * from "./Salestaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d56674",
  null
  
)

export default component.exports